import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, TextLink } from "..";
import {
  BreadcrumbI,
  TextLinkProps,
  UserState,
} from "../../types-interfaces/interfaces";
import Logo from "./Logo";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { setBreadCrumbs } from "../../redux/slices/main/mainSlice";
import SignOutButton from "../auth/sign-out/sign-out-button";
import { IPublicClientApplication } from "@azure/msal-browser";
import MenuLink from "./MenuLink";
import { refreshAccount } from "../../redux/slices/user/userSlice";
import { useAccount, useMsal } from "@azure/msal-react";
import { useUserActions } from "../../services/users/userActions";
import { useConfig } from "../../config/ConfigContext";

interface HeaderPrincipalProps extends React.HTMLAttributes<HTMLElement> {
  user?: string | undefined;
  textLinks?: Array<TextLinkProps> | undefined;
  breadCrumbs?: Array<BreadcrumbI> | undefined;
  instance: IPublicClientApplication;
  setCheckAPI: (value: boolean) => void;
}

function HeaderPrincipal(props: HeaderPrincipalProps) {
  const dispatch = useDispatch();
  const user = useSelector<RootState, UserState>((state) => state.userState);
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { setSession } = useUserActions();
  const config = useConfig();

  const refreshTime = parseInt(config.REFRESH_TOKEN_EVERY_SECONDS);
  const [timerSeconds, setTimerSeconds] = useState<number>(0);
  const [inactivityTimerSeconds, setInactivityTimerSeconds] =
    useState<number>(0);

  useEffect(() => {
    let interval: any = null;
    interval = setInterval(() => {
      setTimerSeconds((prevSeconds: number) => prevSeconds + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let interval: any = null;
    interval = setInterval(() => {
      setInactivityTimerSeconds((prevSeconds: number) => prevSeconds + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const resetInactivityTimer = () => {
    setInactivityTimerSeconds(0);
  };

  useEffect(() => {
    document.addEventListener("keydown", (e) => resetInactivityTimer());
    document.addEventListener("mousemove", (e) => resetInactivityTimer());
    document.addEventListener("click", (e) => resetInactivityTimer());
  }, []);

  useEffect(() => {
    if (
      !user.expiredToken?.status &&
      timerSeconds % refreshTime === 0 &&
      inactivityTimerSeconds < refreshTime &&
      timerSeconds > 0
    ) {
      dispatch(refreshAccount(account, setSession));
      setTimerSeconds(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerSeconds]);

  useEffect(() => {
    if (inactivityTimerSeconds === refreshTime) {
      props.setCheckAPI(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inactivityTimerSeconds]);

  return (
    <div className={props.className}>
      <Card className={props.className + "-top"} />
      <Card className={props.className + "-mid"}>
        <Logo className="logo-principal" />
        <MenuLink
          text="Consultas"
          textLinks={props.textLinks?.filter((tl) => tl.type === "Consultas")}
        />
        {props.textLinks?.filter((tl) => tl.type === "Ingresos").length && (
          <MenuLink
            text="Ingresos"
            textLinks={props.textLinks?.filter((tl) => tl.type === "Ingresos")}
          />
        )}

        {user &&
          user.profiles &&
          user.profiles.length > 0 &&
          props.textLinks &&
          props.textLinks.map(
            (tl, index) =>
              tl.type === undefined &&
              tl.profiles &&
              tl.profiles.length > 0 &&
              tl.profiles.filter((t) => user.profiles.indexOf(t) > -1).length >
                0 && (
                <TextLink
                  key={index}
                  text={tl.text}
                  url={tl.url}
                  onClick={() => {
                    dispatch(setBreadCrumbs([{ name: tl.text, url: tl.url }]));
                  }}
                />
              )
          )}
        <div className={props.className + "-user"}>
          <TextLink
            text={user.name}
            url={"/user=" + user.name}
            className={props.className + "-user-name"}
          />
          <SignOutButton instance={props.instance} />
        </div>
      </Card>
      {props.breadCrumbs && (
        <Breadcrumb className="breadcrumb" breadcrumbs={props.breadCrumbs} />
      )}
    </div>
  );
}

export default HeaderPrincipal;